import { render, staticRenderFns } from "./LinkAccount.vue?vue&type=template&id=b9ae3fd0"
import script from "./LinkAccount.vue?vue&type=script&lang=ts"
export * from "./LinkAccount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports